import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visa-assis',
  templateUrl: './visa-assis.component.html',
  styleUrls: ['./visa-assis.component.css']
})
export class VisaAssisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
